import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { IExame } from '../interfaces/exames/iexame';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ExameService {
  filter !: IExameFilter;
  url: string = `${environment.url}/exams`;

  //url: string = 'http://localhost:3000/exam';

  constructor(private http: HttpClient) { }

  setFilter(filter: IExameFilter) {
    this.filter = filter;
  }

  get(filter : String = '') {
    let urlParams = new URLSearchParams();
    if (this.filter?.name) {
      urlParams.append('name', this.filter.name);
    }
    if (this.filter?.page) {
      urlParams.append('page', this.filter.page);
    }
    let url  = `${this.url}?${urlParams.toString()}`;

    if(filter != '') {
      url  = `${this.url}${filter}`;
    }
    return this.http
      .get(url)
      .pipe(map((res: any) => res)) as Observable<IExame[]>;
    //.pipe(map((res: any) => res['hydra:member'])) as Observable<IExame[]>;
  }

  getByID(id: number) {
    return this.http
      .get(`${this.url}/${id}`)
      .pipe(map((res: any) => res)) as Observable<IExame>;
    //.pipe(map((res: any) => res['hydra:member'])) as Observable<IExame[]>;
  }

  post(req: IExame) {
    return this.http.post(this.url, req) as Observable<IExame>;
  }


  edit(req: IExame, id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.http.patch(
      `${this.url}/${id}`,
      req,
      { headers: headers }
    ) as Observable<IExame>;
  }

  delete(id: number) {
    return this.http.delete(
      `${this.url}/${id}`
    ) as Observable<IExame>;
  }

}


export interface IExameFilter {
  unit: string[],
  name: string,
  page: string
}

export class ExameFilter {
  unit!: string[];
  name!: string;
  page!: string
}
